import { Footer, Container, Link } from "@postenbring/hedwig-react";
import "./temp-footer-styling-fix.scss";
import TrustPilot from "./trust-pilot";

const SwitchLanguageButton = ({ footerData }) =>
    footerData?.switchLanguageLink?.title ? (
        <Footer.ButtonLink href={footerData.switchLanguageLink.url}>
            {footerData.switchLanguageLink.title}
        </Footer.ButtonLink>
    ) : null;

const Buttons = ({ buttons }) => {
    return buttons.map(({ title, url }) => (
        <Footer.ButtonLink key={url} href={url}>
            {title}
        </Footer.ButtonLink>
    ));
};

const MainSections = ({ sections }) => {
    return sections.map(({ heading, items }) => (
        <Footer.LinkSection heading={heading} key={heading}>
            {items?.map(({ title, url }) => (
                <li key={url}>
                    <a href={url} rel="noopener noreferrer">
                        {title}
                    </a>
                </li>
            ))}
        </Footer.LinkSection>
    ));
};

const BottomLinks = ({ links }) => {
    return links.map(({ title, url }) => (
        <Link key={url} href={url}>
            {title}
        </Link>
    ));
};

export const HdsFooter = ({ footerData }) => (
    <Footer>
        <Container>
            <div className="hds-footer__links-and-buttons">
                <div className="hds-footer__button-link-section">
                    <SwitchLanguageButton footerData={footerData} />
                    <Buttons buttons={footerData.buttons} />
                </div>
                <Footer.LinkSections>
                    <MainSections sections={footerData.mainSections} />
                </Footer.LinkSections>
            </div>
            <div
                className={
                    "hds-footer__logo-row kp-footer-logo-row" +
                    (footerData.trustpilotSite ? " hds-footer__logo-row--with-trustpilot" : "")
                }
            >
                <Footer.Logo asChild>
                    <a href={footerData.siteUrl} aria-label={footerData.toFrontPage} />
                </Footer.Logo>
                {footerData.trustpilotSite && <TrustPilot site={footerData.trustpilotSite} />}
            </div>
            <div className="hds-footer__copyright-and-links">
                <span className="hds-footer__copyright">{footerData.copyRightText}</span>
                <BottomLinks links={footerData.bottomLinks} />
            </div>
        </Container>
    </Footer>
);
